import { exportAuditTrailCsv, ExportAuditTrailParams } from '@brands/services/audit_trails/exportAuditTrailCsv';

export const triggerAuditTrailCsvDownload = async (
  params?: ExportAuditTrailParams,
  userRole?: string,
): Promise<void> => {
  const blob = await exportAuditTrailCsv(params, userRole);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'audit_trail.csv';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};
